export enum Constants {
  SET_CONTEST = '@preContest/set_contest',
  SET_USER_SORT = '@preContest/set_user_sort',
  SET_PLAYER_SORT = '@preContest/set_player_sort',
  SET_LINEUP_SORT = '@preContest/set_lineup_sort',
  SET_STACK_SORT = '@preContest/set_stack_sort',
  SET_PAGE = '@preContest/set_page',
  SET_PLAYER_ALL_ROI = '@preContest/set_player_all_roi',
  SET_LINEUP_ALL_ROI = '@preContest/set_lineup_all_roi',
  SET_STACK_ALL_ROI = '@preContest/set_stack_all_roi',
  SET_STACK_ALL_ROI_PAGINATION = '@preContest/set_stack_all_roi_pagination',
  SET_PLAYER_ALL_ROI_PAGINATION = '@preContest/set_player_all_roi_pagination',
  SET_LINEUP_ALL_ROI_PAGINATION = '@preContest/set_lineup_all_roi_pagination',
  SET_AUTH = '@preContest/set_auth',
  SET_SITES = '@preContest/set_sites',
  SET_SPORT = '@preContest/set_sport',
  SET_CONTEST_PLAYERS = '@preContest/set_contest_players',
  SET_DISABLE_PROGRESS_CHECK = '@preContest/set_disable_progress_check',
  SET_SITE = '@preContest/set_site',
  SET_LINEUP_VERIFIED = '@preContest/set_lineup_verified',
  SET_SLATE = '@preContest/set_slate',
  SET_SIMULATED_SLATE = '@preContest/set_simulated_slate',
  SET_TOTAL_ENTRIES = '@preContest/set_total_entries',
  SET_LINEUP_FILE = '@preContest/set_lineup_file',
  SET_PERCENT_TO_FIRST = '@preContest/set_percent_to_first',
  SET_SIM_COUNT = '@preContest/set_sim_count',
  SET_SIMULATION_TIMESTAMP = '@preContest/set_simulation_timestamp',
  SET_SHOW_CACHED_RESULT_ERROR = '@preContest/set_show_cached_result_error',
  SET_RESULTS_LOAD_ERROR = '@preContest/set_results_load_error',
  SET_IS_PARSING_CSV = '@preContest/set_is_parsing_csv',
}